import { SelectSuggest } from '@cms/tpl';
import { Input } from 'antd';
import { CONTAINER } from 'common';
import MonthPicker from 'components/monthpicker/MonthPicker';
import React from 'react';
import OptionService from 'services/OptionService';
import ExportCommonIndex from '../index';
import { COMMON_ELEMENTS } from '../Utils';
const container = CONTAINER.EXPORT_REVENUE_PUBLIC_STREAMING;
const elements = () => {
  const cols = [
    {
      size: 12,
      elements: [
        {
          label: 'Tháng bắt đầu',
          name: 'monthFrom',
          input: <MonthPicker />,
        },
        {
          label: 'Tháng kết thúc',
          name: 'monthTo',
          input: <MonthPicker />,
        },
        {
          label: 'Đối tác',
          name: 'businessPartnerId',
          input: (
            <SelectSuggest suggestApi={OptionService.getBusinessPartners} />
          ),
        },

        {
          label: 'Số hợp đồng',
          name: 'contractNumber',
          input: <Input />,
        },
      ],
    },
    COMMON_ELEMENTS(container, true),
  ];
  return [{ cols }];
};
const ExportRevenuePublicStreamingIndex = () => {
  return (
    <ExportCommonIndex
      formElements={elements()}
      title={'Doanh thu Public Streaming'}
      container={container}
    />
  );
};

export default ExportRevenuePublicStreamingIndex;
